import { Box } from "@mui/material";
import MuiContainer from "@mui/system/Container";
import styled from "styled-components";

export const UpperContainer = styled(MuiContainer)`
  height: 100svh;
  max-width: 100vw;
  position: relative;
`;

export const Container = styled(MuiContainer)`
  max-width: 610px;
  height: calc(100svh - 150px);
  display: flex;
  flex-direction: column;
  padding: 0 16px 12px;

  ${(props) => props.theme.breakpoints.up("mobile")} {
    width: 100%;
    padding: 0 16px 12px;
  }
`;

export const Header = styled(Box)`
  height: 150px;
  background-color: #36bba0;
`;

export const HeaderContent = styled(Box)`
  padding: 60px 24px 0 24px;
  z-index: 2;
`;

export const CardContent = styled(Box)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  top: 108px;
  left: 0;
  right: 0;
`;

export const ContentWithNoLayout = styled(Box)`
  height: 100svh;
  margin: 0 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${(props) => props.theme.breakpoints.up("mobile")} {
    margin: 0;
    width: 100%;
  }
`;
